import useMountEffect from '@restart/hooks/useMountEffect';
import axios from 'axios';
import classNames from 'classnames/bind';
import React, { useState } from 'react';

import styles from './Window.module.scss';

import ViewFinder from '@/components/ui/ViewFinder';

const cx = classNames.bind(styles);

const Window = ({ robot }) => {
  const [isLoading, setLoading] = useState(false);
  const [videoUrls, setVideoUrls] = useState();

  useMountEffect(() => {
    load();
  });

  const load = () => {
    if (!robot.metadata['VIDEO_TYPE']) {
      setVideoUrls(null);
      return;
    }

    const body = { type: robot.metadata['VIDEO_TYPE'] };
    switch (body.type) {
      // RTSP (e.g. Rifatron)
      case 'RTSP':
        body.payload = {
          url: robot.metadata['VIDEO_RTSP_URL'],
          username: robot.metadata['VIDEO_RTSP_USERNAME'],
          password: robot.metadata['VIDEO_RTSP_PASSWORD'],
        };
        break;

      // 3rd Party WebRTC (e.g. Smatii)
      case 'WebRTC':
        body.payload = {
          url: robot.metadata['VIDEO_WEBRTC_URL'],
          token: robot.metadata['VIDEO_WEBRTC_TOKEN'],
        };
        break;

      default:
        break;
    }

    setLoading(true);
    axios.post(`${process.env.REACT_APP_STREAMHUB_API_URL}/robots/${robot.id}`, body).then((result) => {
      const { success, data } = result.data;

      setVideoUrls(success ? data.urls : []);
      setTimeout(() => setLoading(false), 1000);
    });
  };

  return (
    <div className={cx('container')}>
      {isLoading && (
        <div className={cx('wrapper')}>
          <div className={cx(['title', 'loading'])}>Loading</div>
          <div className={cx('desc')}>Searching for a video channels.</div>
        </div>
      )}
      {!isLoading && (
        <>
          {videoUrls === null && (
            <div className={cx('wrapper')}>
              <div className={cx('title')}>No Camera</div>
              <div className={cx('desc')}>No video stream settings.</div>
            </div>
          )}
          {videoUrls?.length === 0 && (
            <div className={cx('wrapper')}>
              <div className={cx('title')}>No Channels</div>
              <div className={cx('desc')}>Video channel not detected.</div>
            </div>
          )}
          {videoUrls?.map((videoUrl, index) => (
            <ViewFinder key={index} url={videoUrl} />
          ))}
        </>
      )}
    </div>
  );
};

export default Window;
